import Config from "../../../../../../shared/src/ranj/app/config/Config";

export default class GameConfig extends Config {

    constructor() {
        super();
    }

    getSkillForBehaviour(behaviour) {
        const map = this.getValue("behavioursPerSkill");
        for (const skill in map) {
            if (map[skill].indexOf(behaviour)>-1) {
                return skill;
            }
        }
        throw new Error(`No skill specified for behaviour '${behaviour}'`);
    }

    getBehaviourForKeyMomentId(keyMomentId) {
        const map = this.getValue("behavioursPerKeyMoment");
        const behaviour = map[keyMomentId];
        if (behaviour) {
            return behaviour;
        }
        throw new Error(`No behaviour specified for keyMoment '${keyMomentId}'`);
    }
}